import React, { useEffect } from "react";
import VWLoading from "../../components/vwLoading/vwLoading";
import Message from "../../CommonData/Data/Message";
import moment from "moment";
import { connect } from "react-redux";
import { clearDeviceLog, getDeviceLogs } from "../../store/device/actions";
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChessKing,
    faChessPawn,
    faCommentDots,
    faExchangeAlt,
    faRandom,
    faSyncAlt,
    faThumbsDown,
    faThumbsUp,
    faTools,
    faTrashAlt
} from "@fortawesome/free-solid-svg-icons";
import { Button, Table } from "reactstrap";

const DeviceLog = (props) => {
    const { selectedDevice, deviceLog, errorMessage, isDeviceLogPending } = props;
    const { uid, modelNo, deviceKey } = selectedDevice || {};
    console.log("selectedDevice: ", selectedDevice);
    const functionArr = [
        {
            name: "CREATE_DEVICE",
            title: "DEVICE CREATED",
            from: "Created By",
            to: "Created For",
            color: "#FD7F20",
            icon: <FontAwesomeIcon icon={faTools} />
        },
        {
            name: "DELETE_DEVICE",
            title: "DEVICE DELETED",
            from: "Deleted By",
            to: "Deleted For",
            color: "#FB4570",
            icon: <FontAwesomeIcon icon={faTrashAlt} />
        },
        {
            name: "SUBMIT_RETURN_REQUEST",
            title: "RETURN REQUESTED",
            from: "Requested By",
            to: "Requested To",
            color: "#189AB4",
            icon: <FontAwesomeIcon icon={faCommentDots} />
        },
        {
            name: "REJECT_RETURN_REQUEST",
            title: "RETURN REJECTED",
            from: "Rejected By",
            to: "Rejected For",
            color: "#FF5765",
            icon: <FontAwesomeIcon icon={faThumbsDown} />
        },
        {
            name: "APPROVE_RETURN_REQUEST",
            title: "RETURN APPROVED",
            from: "Approved By",
            to: "Approved For",
            color: "#15B5B0",
            icon: <FontAwesomeIcon icon={faThumbsUp} />
        },
        {
            name: "ASSIGN_DEVICE",
            title: "DEVICE ASSIGNED",
            from: "Assigned By",
            to: "Assigned To",
            color: "#18A558",
            icon: <FontAwesomeIcon icon={faRandom} />
        },
        {
            name: "AUTO_ASSIGN_DEVICE_TO_RETAILER",
            title: "DEVICE AUTO ASSIGN FOR DELETED USER",
            from: "Assigned By",
            to: "Assigned To",
            color: "#8FA01F",
            icon: <FontAwesomeIcon icon={faRandom} />
        },
        {
            name: "ASSIGN_TRANSFER",
            title: "TRANSFER",
            from: "Transferred By",
            to: "Transferred To",
            color: "#FF8882",
            icon: <FontAwesomeIcon icon={faSyncAlt} />
        },
        {
            name: "CREATE_AS_SLAVE_BY_RETAILER",
            title: "CONVERTED AS SLAVE",
            from: "Created By",
            to: "Created To",
            color: "#FB6B90",
            icon: <FontAwesomeIcon icon={faChessPawn} />
        },
        {
            name: "CREATE_AS_MASTER_BY_RETAILER",
            title: "CONVERTED AS MASTER",
            from: "Created By",
            to: "Created To",
            color: "#050A61",
            icon: <FontAwesomeIcon icon={faChessKing} />
        },
        {
            name: "CREATE_AS_MASTER_BY_CUSTOMER",
            title: "CONVERTED AS MASTER",
            from: "Created By",
            to: "Created To",
            color: "#050A61",
            icon: <FontAwesomeIcon icon={faChessKing} />
        },
        {
            name: "CREATE_AS_SLAVE_BY_CUSTOMER",
            title: "CONVERTED AS SLAVE",
            from: "Created By",
            to: "Created To",
            color: "#FB6B90",
            icon: <FontAwesomeIcon icon={faChessPawn} />
        },
        {
            name: "REMOVE_SLAVE_FROM_CUSTOMER",
            title: "SLAVE DEVICE REMOVED",
            from: "Removed By",
            to: "Removed To",
            color: "#836750",
            icon: <FontAwesomeIcon icon={faChessPawn} />
        },
        {
            name: "REMOVE_MASTER_FROM_CUSTOMER",
            title: "MASTER DEVICE REMOVED",
            from: "Removed By",
            to: "Removed To",
            color: "#206594",
            icon: <FontAwesomeIcon icon={faChessKing} />
        },
        {
            name: "RETURN_DEVICE",
            title: "DEVICE RETURNED",
            from: "Returned By",
            to: "Returned To",
            color: "#D773A2",
            icon: <FontAwesomeIcon icon={faExchangeAlt} />
        },
    ]
    useEffect(() => {
        if (uid) {
            props.getDeviceLogs(uid);
        }

        return () => {
            props.clearDeviceLog();
        }
    }, [uid])

    const handleReloadLog = () => {
        props.getDeviceLogs(uid);
    }

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center">
                <div className="fs-6 fw-bold d-flex justify-content-between">
                    <div className="px-2">
                        Selected Device UID -   <span className="bg-primary text-white p-1 rounded-1">{uid || "NA"}</span>
                    </div>
                    <div className="px-2">
                        Model No. - <span className="bg-primary text-white p-1 px-2 rounded-1">{modelNo || "NA"}</span>
                    </div>
                    <div className="px-2">
                        Device Key - <span className="bg-primary text-white p-1 rounded-1">{deviceKey || "NA"}</span>
                    </div>
                </div>
                {(deviceLog && deviceLog.length > 0) &&
                    <Button
                        color="primary"
                        size="sm"
                        onClick={handleReloadLog}
                    >
                        <FontAwesomeIcon icon={faSyncAlt} />  Refresh
                    </Button>
                }
            </div>
            {errorMessage && (
                <div className="my-2">
                    <Message
                        type="danger"
                        defaultMessage={errorMessage}
                        baseClassName="alert"
                    />
                </div>
            )}
            {!uid && (
                <div className="my-2">
                    <Message
                        type="danger"
                        defaultMessage={"Selected device has no UID. Without it, you can't view the device log."}
                        baseClassName="alert"
                    />
                </div>
            )}
            {
                isDeviceLogPending ? <VWLoading height={40} width={40} /> :
                    deviceLog && deviceLog.length > 0 ?
                        <div style={{ maxHeight: "75vh", overflowY: "auto" }}>
                            <VerticalTimeline>
                                {deviceLog.map((log) => {
                                    const matchStyleArr = functionArr && functionArr.filter((action) => action.name === log.moduleAction);
                                    const matchStyleObj = matchStyleArr && matchStyleArr.length > 0 ? matchStyleArr[0] : {};
                                    return (
                                        <VerticalTimelineElement
                                            className="vertical-timeline-element--work"
                                            date={moment(log.actionTimeStamp).format("DD MMM YYYY HH:mm")}
                                            dateClassName="text-dark fw-bold"
                                            contentStyle={{ background: '#D8E1E7', color: '#002952' }}
                                            contentArrowStyle={{ borderRight: '7px solid #D8E1E7' }}
                                            iconStyle={{ background: matchStyleObj.color, color: '#fff' }}
                                            icon={matchStyleObj.icon}
                                        >
                                            <div className="fs-5 fw-bold"
                                                style={{
                                                    backgroundColor: matchStyleObj.color,
                                                    color: "white",
                                                    padding: "5px",
                                                    marginBottom: "5px",
                                                    width: "fit-content",
                                                    borderRadius: "8px"
                                                }}>
                                                {`${matchStyleObj.title} (${log.actionByUserRole})` || log.moduleAction}
                                            </div>
                                            <Table className="align-middle">
                                                <tr>
                                                    <th>
                                                        <div className="text-white text-nowrap rounded-1 p-1" style={{ backgroundColor: "#1C2143", width: "fit-content", wordBreak: "break-all" }}>{matchStyleObj.from}</div>
                                                    </th>
                                                    <td className="ps-1" style={{ wordBreak: "break-all" }}>{`${log.actionByUserEmail} (${log.actionByUserRole ? log.actionByUserRole : "NA"})`}</td>
                                                </tr>
                                                {log.actionToUserEmail && <tr>
                                                    <th>
                                                        <div className="text-white text-nowrap rounded-1 p-1" style={{ backgroundColor: "#DB1F48", width: "fit-content", wordBreak: "break-all" }}> {matchStyleObj.to}</div>
                                                    </th>
                                                    <td className="ps-1" style={{ wordBreak: "break-all" }}>{`${log.actionToUserEmail} (${log.actionToUserRole ? log.actionToUserRole : "NA"})`}</td>
                                                </tr>}
                                            </Table>
                                            <p>
                                                {log.comments}
                                            </p>
                                        </VerticalTimelineElement>
                                    )
                                })
                                }
                            </VerticalTimeline>
                        </div>
                        :
                        <div className="text-danger d-flex justify-content-center align-items-center flex-column" style={{ minHeight: "100px" }}>
                            <div>
                                <em className="fas fa-database text-danger fs-3"></em>
                            </div>
                            <div className="fs-5">
                                No Records Found
                            </div>
                        </div>
            }
        </div >
    )
}

const mapStateToProps = (state) => ({
    selectedDevice: state.device.selectedDevice,
    isDeviceLogPending: state.device.isDeviceLogPending,
    deviceLog: state.device.deviceLog,
    errorMessage: state.device.deviceLogErrorMessage,
});

const mapDispatchToProps = (dispatch) => ({
    getDeviceLogs: (selectedDeviceUID) => dispatch(getDeviceLogs(selectedDeviceUID)),
    clearDeviceLog: () => dispatch(clearDeviceLog()),
})

export default connect(mapStateToProps, mapDispatchToProps)(DeviceLog);